<template>
  <DashboardKpi
    v-if="store.state.me.grp_name_bez != 'Certification'"
    :plants="store.getters.getPlants"
    :organisation="store.getters.getOrganisation"
    :viewMode="currentTabComponent"
    :searchQuery="filterPlant"
    :activeFilter="activeFilter"
    :allAvailableTypes="allAvailableTypes"
    @updateViewMode="updateViewMode"
    @updateSearch="updateSearch"
    @updateTypeFilter="setTypeFilter"
    @openPlant="handleOpenPlant"
  >
  </DashboardKpi>

  <template v-if="store.state.me.grp_name_bez == 'Certification'">
    <UserPdf></UserPdf>
  </template>
  <template v-else-if="store.getters.getPlants">
    <component ref="dashboardRef" :is="currentTabComponent" v-bind="currentProperties"></component>
  </template>
</template>

<script>
import { computed, watch, ref, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useResponsive } from '../composables/useResponsive';
import GoogleMaps from '@/components/dashboard/GoogleMaps.vue';
import ListDashboard from '@/components/dashboard/ListDashboard.vue';
import ListDashboardNew from '@/components/dashboard/ListDashboardNew.vue';
import TileDashboard from '@/components/dashboard/TileDashboard.vue';
import DashboardKpi from '@/components/kpi/DashboardKpi.vue';
import UserPdf from '@/views/certification/UserPdf.vue';

export default {
  name: 'DashboardView',
  components: {
    GoogleMaps,
    ListDashboard,
    ListDashboardNew,
    TileDashboard,
    DashboardKpi,
    UserPdf,
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    // Use the shared responsive composable
    const { isMobile } = useResponsive();
    const me = computed(() => store.state.me);
    // Reaktiver Zustand
    const currentTabComponent = ref('');
    const userSelectedViewMode = ref('');
    const activeFilter = ref([]);
    const filterPlant = ref('');

    // Handle view mode updates from header
    function updateViewMode(mode) {
      currentTabComponent.value = mode;
    }

    // Handle search updates from header
    function updateSearch(query) {
      filterPlant.value = query;
    }

    const dashboardRef = ref(null);

    async function handleOpenPlant(plant) {
      await nextTick();
      if (dashboardRef.value && dashboardRef.value.openInfoWindow) {
        dashboardRef.value.openInfoWindow(plant);
      }
    }
    onMounted(() => {
      console.log('Dashboard Mounted');
      if (isMobile.value) {
        currentTabComponent.value = 'ListDashboard';
      } else if (me.value.standard_dashboard) {
        currentTabComponent.value = me.value.standard_dashboard;
      } else {
        currentTabComponent.value = 'TileDashboard';
      }
      userSelectedViewMode.value = currentTabComponent.value;

      // Deep link: store pending plant ID for TileDashboard to open
      // NOTE: mobile deep link (ListDashboard) is explicitly out of scope for this phase.
      // Do NOT set currentTabComponent here — let the existing responsive logic
      // determine which component mounts. On desktop, TileDashboard will already
      // be selected by the code above. On mobile, ListDashboard is mounted but
      // has no openInfoWindow method, so we only write to sessionStorage and let
      // TileDashboard handle it if and when it is the active component.
      const plantId = route?.query?.plant;
      if (plantId) {
        sessionStorage.setItem('deepLinkPlantId', String(plantId));
      }
    });

    // Dashboard-Ansicht anpassen, falls der User nichts geändert hat
    watch(me, (newMe) => {
      if (newMe && !isMobile.value) {
        currentTabComponent.value = newMe.standard_dashboard || 'TileDashboard';
        console.log('Konfiguration geladen:', newMe);
      }
    });

    // Watch for changes in screen size and update view mode
    watch(isMobile, (newIsMobile, oldIsMobile) => {
      // If transitioning to mobile, switch to list view
      if (!oldIsMobile && newIsMobile) {
        currentTabComponent.value = 'ListDashboard';
      }
      // If transitioning back to desktop, restore user's selected view
      else if (oldIsMobile && !newIsMobile) {
        currentTabComponent.value = userSelectedViewMode.value;
      }
    });

    watch(currentTabComponent, () => {
      //hasUserChangedTab.value = true;
    });

    // Watch for user changes to viewMode and update userSelectedViewMode
    watch(currentTabComponent, (newValue) => {
      // Only update userSelectedViewMode if we're not on mobile
      // This prevents the list view (forced on mobile) from becoming the user's selection
      if (!isMobile.value) {
        userSelectedViewMode.value = newValue;
      }
    });

    // Berechnete Eigenschaften
    const allAvailableTypes = computed(() =>
      Array.from(new Set(store.getters.getPlants.map((plant) => plant.type))).filter((n) => n)
    );

    const currentProperties = computed(() => {
      const filterPlantLower = filterPlant.value.toLowerCase();
      console.log('filterPlantLower:', filterPlantLower);

      let plants = store.getters.getPlants.filter((plant) =>
        plant.name.toLowerCase().includes(filterPlantLower)
      );

      if (activeFilter.value.length > 0) {
        plants = plants.filter((plant) => activeFilter.value.includes(plant.type));
      }

      return { plants };
    });

    // Methoden
    const setTypeFilter = (typ) => {
      console.log('entry setTypeFilter');

      if (activeFilter.value.includes(typ)) {
        const pos_delete = activeFilter.value.indexOf(typ);
        console.log('pos_delete:', pos_delete);
        activeFilter.value.splice(pos_delete, 1);
      } else {
        activeFilter.value.push(typ);
      }
      console.log('this.activeFilter', activeFilter.value);
      console.log('exit setTypeFilter');
    };

    return {
      store,
      route,
      currentTabComponent,
      activeFilter,
      filterPlant,
      allAvailableTypes,
      currentProperties,
      setTypeFilter,
      isMobile,
      updateSearch,
      updateViewMode,
      dashboardRef,
      handleOpenPlant,
    };
  },
};
</script>

<style scoped>
.filter-selected {
  border: 2px solid #007bff;
  border-radius: 5px;
}
</style>
